/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentCard/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import ParentCompanyAndLocation from './ParentCompanyAndLocation/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TreatmentCard({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentCard"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="TreatmentCard.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-b12TX': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TreatmentCard.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-b12TX': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-b12TX': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Treatment card"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Choose how you display past appointments — through a compact table or a detailed timeline — and decide whether to show full or shortened notes text, all for a tailored view."
/>
<ParentCompanyAndLocation
  viewPath={`${viewPath}/ParentCompanyAndLocation`}
/>
</div>
<div
  data-testid="TreatmentCard.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-4-b12TX': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<div
  data-testid="TreatmentCard.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-b12TX': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-b12TX': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-1-b12TX': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}